import React from "react";
import "./Empty.css";

const Empty = () => {
  return <div className="h-100 notFound"></div>;
};

export default Empty;
